import { FloatingOverlay } from '@floating-ui/react'
import styled from 'styled-components'

export const Overlay = styled(FloatingOverlay)({
  backgroundColor: 'rgba(33, 33, 33, 0.2)',
  display: 'grid',
  placeItems: 'center',
  zIndex: 99,
})
